import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import useGlobalDebounceHandler from "./useGlobalDebounceHandler";
import { IGetServiceProps } from "@api/types/globalService.types";
import { urlUtility } from "@repo/utilities/url.utility.ts";
interface IPincodeGetServiceProps extends IGetServiceProps {
  refetchOnMount?: boolean;
}
export const useGetAllPincodeServices = ({
  page = "1",
  per_page = "15",
  enableQuery = true,
  cityId = "",
}: IGetServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);
  const urlQueries = urlUtility.getUrlQueries(location.search)
  const cityName = urlQueries["city_name"] ?? ""
  const pincodeNo = urlQueries["pincode"] ?? ""
  const allPincodesService = useQuery({
    queryKey: [...CACHE_KEYS.PINCODES, page, cityName, pincodeNo, debouncedQuery, per_page],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.PINCODES,
        searchParams: {
          "filter[pincode]": debouncedQuery || pincodeNo,
          "filter[city_id]": cityId,
          "filter[city.name]": cityName,
          page,
          per_page,
          include: "city,city.state",
        },
      }),
    enabled: enableQuery,
  });
  return {
    services: { allPincodesService },
    states: { setSearchQuery, searchQuery },
  };
};
export const useSinglePincodeService = ({
  enableQuery = true,
  pincode,
  refetchOnMount = false,
}: IPincodeGetServiceProps) => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const singlePincodeService = useQuery({
    queryKey: [...CACHE_KEYS.PINCODES, urlQueries.pincode],
    queryFn: () =>
      handleGlobalGetRequestQuery({
        url: URLS.PINCODES,
        searchParams: {
          "filter[pincode]": urlQueries.pincode || pincode || "",
          include: "city,city.state",
        },
      }),
    enabled: enableQuery,
    refetchOnMount: refetchOnMount ? "always" : false,
  });
  return { service: { singlePincodeService } };
};
